import React from 'react';
import { MenuItem } from '@mui/material';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';

import * as S from './styled';

const Select = ({ options, onChange, value, label, ...props }) => {
  return (
    <S.FormControlBlock>
      <InputLabel>{label}</InputLabel>
      <S.StyledSelect
        displayEmpty={true}
        value={value}
        input={<OutlinedInput label={label} />}
        onChange={onChange}
        {...props}>
        {options.map((el, i) => {
          return (
            <MenuItem key={i + el.value + el.name} value={el.value}>
              {el.name}
            </MenuItem>
          );
        })}
      </S.StyledSelect>
    </S.FormControlBlock>
  );
};

export default Select;
